import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LuCalendarDays, LuPlus } from "react-icons/lu";

import api from '../../services/api';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext from '../../contexts/language';

export default function Agenda() {

    const { language } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    
    const [events, setEvents] = useState([]);

    async function loadEvents(){
        setLoading(true);
        try{
            const response = await api.post(`/events`);
            setEvents(response.data.content.events);
            setLoading(false);
        }catch(err){
            setLoading(false);
        }
    }

    useEffect(() => {
        loadEvents();
    }, []);

    function toggle(id){
        const wrapper = document.querySelector('#event_' + id);
        wrapper.classList.toggle('event-open');
    }

    function addCalendar(title, start, end){
        let link = `https://calendar.google.com/calendar/r/eventedit?text=${title}&dates=${start}/${end}&ctz=America/Sao_Paulo`;
        window.open(link, '_blank');
    }

    return (
        <div className="page">
            <Header />
            <div className="content">
                <div className="full mt-30 mb-40 text-center form">
                    <h3 className="title_b color_3 mt-30 mb-30">
                        {language.menu_agenda}
                    </h3>
                    <div className={`all-events mt-10`}>
                        {lang==='pt' &&
                        <div className="event-text">
                            <div className="big-text">
                                <p><strong>Ausência, Presença, Excesso nos Estados Mentais Primitivos: desafios clínicos</strong></p>
                            </div>
                            <div className="small-text">
                                <p><span>São Paulo, 30 de julho a 1º de agosto de 2026<br />Atividades pré-conferência: 29 de julho de 2026</span></p>
                                <p>A conferência é uma cooperação entre o The Frances Tustin Memorial Trust (FTMT), a Sociedade Brasileira de Psicanálise de São Paulo, a Sociedade Psicanalítica do Rio de Janeiro e o Grupo Prisma de Psicanálise e Autismo</p>
                                <p><strong><span>Local:</span> SBPSP Sociedade Brasileira de Psicanálise de São Paulo<br />Endereço: Av. Dr. Cardoso de Melo, 1450, São Paulo</strong><br />(com 4 salas complementares no Station Training Center)</p>
                            </div>
                        </div>}
                        {lang==='es' &&
                        <div className="event-text">
                            <div className="big-text">
                                <p><strong>Ausencia, Presencia, Exceso en los Estados Mentales Primitivos: desafíos clínicos</strong></p>
                            </div>
                            <div className="small-text">
                                <p><span>São Paulo, del 30 de julio al 1 de agosto de 2026<br />Actividades pre-conferencia: 29 de julio de 2026</span></p>
                                <p>La conferencia es una cooperación entre The Frances Tustin Memorial Trust (FTMT), la Sociedad Brasileña de Psicoanálisis de São Paulo, la Sociedad Psicoanalítica de Río de Janeiro y el Grupo Prisma de Psicoanálisis y Autismo</p>
                                <p><strong><span>Sede:</span> SBPSP Sociedad Brasileña de Psicoanálisis de São Paulo<br />Dirección: Av. Dr. Cardoso de Melo, 1450, São Paulo</strong><br />(con 4 salas complementarias en el Station Training Center)</p>
                            </div>
                        </div>}
                        {lang==='en' &&
                        <div className="event-text">
                            <div className="big-text">
                                <p><strong>Absence, Presence, Excess in Primitive Mental States: clinical challenges</strong></p>
                            </div>
                            <div className="small-text">
                                <p><span>São Paulo, July 30 to August 1, 2026<br />Pre-conference activities: July 29, 2026</span></p>
                                <p>The conference is a cooperation between The Frances Tustin Memorial Trust (FTMT), The Brazilian Society of Psychoanalysis of São Paulo, The Psychoanalytic Society of Rio de Janeiro and Prisma Group of Psychoanalysis and Autism</p>
                                <p><strong><span>Venue:</span> SBPSP Brazilian Society of Psychoanalysis of São Paulo<br />Address: Av. Dr. Cardoso de Melo, 1450, São Paulo</strong><br />(with 4 complementary rooms at Station Training Center)</p>
                            </div>
                        </div>}

                        {events.map(item => (
                        <div key={`events-${item.id}`} className="event-box">
                            <div className="event-container">
                                <div className="event-title">
                                    <LuCalendarDays />
                                    <span>{lang==='pt' ? item.title : lang==='es' ? item.title_es : item.title_en} {item.url=='29-julho' && ' - ' + language.pre_conference}</span>
                                </div>
                            </div>
                                
                            {(lang==='es' && item.url=='31-julho') &&
                            <p className="px-3 py-1 fw-semibold text-left">
                                ⚠️ Si un número considerable de personas prefiere tener un seminario clínico durante la conferencia en español, organizaremos dicha opción. Si alguien está interesado en esta alternativa, por favor contáctenos por correo electrónico a: <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a>
                            </p>}

                            {item.event.map(event => (
                            <div key={`event-${event.id}`} className={`event-content dont-click`}>
                                <div className={`event-hour ${lang}`} onClick={() => addCalendar(lang==='pt' ? event.calendar_title : lang==='es' ? event.calendar_title_es : event.calendar_title_en, event.calendar_start, event.calendar_end)}>
                                    {event.time_start==event.time_end ?
                                    <span>{lang==='pt' ? event.time_start : lang==='es' ? event.time_start_es : event.time_start_en}</span>:
                                    <span>{lang==='pt' ? event.time_start : lang==='es' ? event.time_start_es : event.time_start_en} - {lang==='pt' ? event.time_end : lang==='es' ? event.time_end_es : event.time_end_en}</span>}
                                    <a className="add-calendar" href="javascript:;" onClick={() => addCalendar(lang==='pt' ? event.calendar_title : lang==='es' ? event.calendar_title_es : event.calendar_title_en, event.calendar_start, event.calendar_end)}>
                                        <LuPlus />
                                        <span>{lang==='pt' ? 'Add agenda' : lang==='es' ? 'Add calendario' : 'Add calendar'}</span>
                                    </a>
                                </div>
                                <div className="event-wrapper">
                                    <div className={`event-content-wrapper ${(event.description) ? 'has-open':''}`} onClick={() => (event.description) && toggle(event.id)}>
                                        <div className="event-subtitle" dangerouslySetInnerHTML={{__html: lang==='pt' ? event.title : lang==='es' ? event.title_es : event.title_en}} />
                                        {(event.description) &&
                                        <div id={`event_${event.id}`} className={`event-close`}>
                                            {event.description &&<div className={`event-description`} dangerouslySetInnerHTML={{__html: lang==='pt' ? event.description : lang==='es' ? event.description_es : event.description_en}} />}
                                        </div>}
                                    </div>
                                    {event.panel &&
                                    <div className={`event-content-wrapper`}>
                                        <div className="event-subtitle" dangerouslySetInnerHTML={{__html: lang==='pt' ? event.panel : lang==='es' ? event.panel_es : event.panel_en}} />
                                    </div>}
                                </div>
                            </div>))}
                        </div>))}
                        <div className="event-text">
                            {lang==='pt' &&
                            <div className="small-text">
                                <p className="text-justify">As conferências principais em inglês, e as discussões subsequentes, terão tradução simultânea para português e espanhol. A conferência principal em português, na quinta-feira, e a discussão subsequente, terão tradução simultânea para inglês e espanhol. O texto escrito de todas as palestras estará disponível em inglês, português e espanhol.</p>
                                <p className="text-justify"><strong>Mais detalhes e inscrições:</strong> <a href="https://tustinsaopaulo.org" className="link">tustinsaopaulo.org</a></p>
                                <p className="text-justify"><strong>Para dúvidas, por favor entre em contato com:</strong> Dra. Maria Thereza de Barros França e Antonio Adolfo Fonseca pelo e-mail: <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></p>
                            </div>}
                            {lang==='es' &&
                            <div className="small-text">
                                <p className="text-justify">Las conferencias magistrales en inglés, y las discusiones posteriores, contarán con traducción simultánea al portugués y español. La conferencia magistral en portugués, el jueves, y la discusión posterior, tendrán traducción simultánea al inglés y español. El texto escrito de todas las conferencias estará disponible en inglés, portugués y español.</p>
                                <p className="text-justify"><strong>Más detalles e inscripciones:</strong> <a href="https://tustinsaopaulo.org" className="link">tustinsaopaulo.org</a></p>
                                <p className="text-justify"><strong>Para consultas, por favor comuníquese con:</strong> Dra. Maria Thereza de Barros França y Antonio Adolfo Fonseca al correo: <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></p>
                            </div>}
                            {lang==='en' &&
                            <div className="small-text">
                                <p className="text-justify">The keynote lectures in English, and the discussions following thereafter, will have simultaneous translation into Portuguese and Spanish. The keynote lecture in Portuguese, on Thursday, and the discussion following thereafter, will have simultaneous translation into English and Spanish. The written text of all lectures will be available in English, Portuguese and Spanish.</p>
                                <p className="text-justify"><strong>More details and registration:</strong> <a href="https://tustinsaopaulo.org" className="link">tustinsaopaulo.org</a></p>
                                <p className="text-justify"><strong>For queries please address:</strong> Dr. Maria Thereza de Barros França and Antonio Adolfo Fonseca at: <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></p>
                            </div>}

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
